import moment from 'moment';
import { assoc } from 'ramda';
import { chain, concat, isString, isUndefined, reduce } from 'lodash';
import { decode } from 'iconv-lite';
import { Buffer } from 'buffer';

import { DATE_FORMATS } from 'constants/dateFormats';
import { toFormat } from 'helpers/fieldsHelpers';

export function dateToStr(date) {
    return moment(date, DATE_FORMATS.format).isValid() ? moment(date, DATE_FORMATS.format).format(DATE_FORMATS.parse) : date;
}

export function strToDate(date, parse = DATE_FORMATS.parse, format = DATE_FORMATS.format) {
    let formatedDate = toFormat(date, parse, format);
    return (date !== '0') && formatedDate ? formatedDate : '';
}

export function strToDateMonth(date) {
    return strToDate(date, DATE_FORMATS.monthYearParse, DATE_FORMATS.monthYearFormat);
}

export function strToTime(time = '') {
    const strTime = time.length === 3 ? '0' + time : time;
    return time !== '0' ? toFormat(strTime, DATE_FORMATS.timeParse, DATE_FORMATS.timeFormat) : '';
}

export function timeToStr(time) {
    return toFormat(time, DATE_FORMATS.timeFormat, DATE_FORMATS.timeParse);
}

export function formatDate(date) {
    let result = moment(date, DATE_FORMATS.parse);
    return result.isValid() && result.year() ? result.format(DATE_FORMATS.format) : '';
}

export function documentType(document) {
    const isDocument = document.fileType || document.xmlType;

    return assoc('type', isDocument ? 'Document' : '', document);
}

export function education(ed) {
    const opts = { graduation: '', institute: ' - ', speciality: ', ', levelName: ', ', typeName: ', ' };

    return chain(opts).each().reduce((full, separator, key) => {
        return full += isUndefined(ed[key]) || ed[key] === '' || ed[key] === 0 ? '' : separator + ed[key];
    }, '').value();
}

export function partsInProject(groups) {
    return reduce(groups, (result, value) => {
        if (isString(value)) {
            let groupName = {
                text: value + ':'
            };

            result.push(groupName);
        } else {
            result = concat(result, value);
        }

        return result;
    }, []);
}

export const decodeBase64Win1251 = data => {
    return decode(new Buffer(data, 'base64'), 'win1251');
}
